import type { IdTokenResult, User } from "firebase/auth";

import type { IUser } from "~/types";

export default function formatUser(user: User, idTokenResult: IdTokenResult): IUser {
  const cachedUser = unref(useUser());

  /**
   * Will be updated after login
   */
  const hasLeaguesAccess = cachedUser?.hasLeaguesAccess || false;
  const hasOrganizationsAccess = cachedUser?.hasOrganizationsAccess || false;
  const tenantId = cachedUser?.tenantId || "";
  const hasTenantAdminRole = cachedUser?.hasTenantAdminRole || false;
  const isCoachToolsEnabled = cachedUser?.isCoachToolsEnabled ?? false;
  const isB2CUser = cachedUser?.isB2CUser ?? false;
  const isB2COwner = cachedUser?.isB2COwner ?? false;
  const canMigrateB2CToAdvantage = cachedUser?.canMigrateB2CToAdvantage ?? false;

  return {
    uid: user.uid,
    email: user.email,
    fullName: user.displayName,
    phoneNumber: user.phoneNumber,
    hasPasswordProvider: Boolean(user.providerData.find((provider) => provider.providerId === "password")),
    hasEmailVerified: user.emailVerified,
    hasB2BAccount: Boolean(idTokenResult.claims.isB2BUser),
    hasVidswapAccount: Boolean(idTokenResult.claims.isVsUser),
    hasSuperAdminRole: Boolean(idTokenResult.claims.group && idTokenResult.claims.group === "admin"),
    hasTenantAdminRole,
    hasLeaguesAccess,
    tenantId,
    hasOrganizationsAccess,
    isCoachToolsEnabled,
    isB2CUser,
    isB2COwner,
    canMigrateB2CToAdvantage,
    teamsSports: [],
    customData: {},
  };
}
